import { useSelector } from "react-redux";
import { difficultyOptionsUpdated } from "../../../constants";
import OptionsDropDown from "../../UI/options_drop_down/options_drop_down";
import classes from "../criteriaSubmission.module.css";
import { selectFormData } from "../../../slices/form";

const DifficultyLevel = ({ isLoading, handleInputChange }) => {
  const formData = useSelector(selectFormData);

  return (
    <div className={classes["input-container"]}>
  <label className={classes.formLabel} htmlFor="difficulty_level">Select a difficulty level:</label>
      <OptionsDropDown
        name="difficulty_level"
        onChangeHandler={handleInputChange}
        options={[{ name: "None selected", value: "" }, ...difficultyOptionsUpdated]}
        isDisabled={isLoading}
        isRequired={true}
        value={formData?.difficulty_level || ""}
      />
    </div>
  );
};

export default DifficultyLevel;
